import { StyleSheet } from 'react-native'
import { Colors } from 'APP/Themes'

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.appBg,
  },
})
